import { render, staticRenderFns } from "./SourceNew.vue?vue&type=template&id=597a4b3f&"
import script from "./SourceNew.vue?vue&type=script&lang=js&"
export * from "./SourceNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports